import moment from "moment";

const duration = (value, unit) => {
  if (value !== 0 && !value) return null;
  unit = unit || "milliseconds";
  const duration = moment.duration(value, unit);
  let formattedValue = `${duration.seconds()}s`;

  if (duration.minutes()) formattedValue = `${duration.minutes()}m ` + formattedValue;
  if (duration.hours()) formattedValue = `${duration.hours()}h ` + formattedValue;
  if (duration.days()) formattedValue = `${duration.days()}d ` + formattedValue;
  if (duration.weeks()) formattedValue = `${duration.weeks()}w ` + formattedValue;
  if (duration.months()) formattedValue = `${duration.months()}m ` + formattedValue;
  if (duration.years()) formattedValue = `${duration.years()}y ` + formattedValue;

  return formattedValue;
};

const date = value => {
  if (!value) return null;
  return moment(value).format("MMM D, YYYY");
};

const dateShort = value => {
  if (!value) return null;
  return moment(value).format("MM/DD/YYYY");
};

const dateMedium = value => {
  if (!value) return null;
  return moment(value).format("MM/DD/YYYY h:mm a");
};

const dateLong = value => {
  if (!value) return null;
  return moment(value).format("MMMM Do YYYY, h:mm:ss a");
};

const relative = value => {
  if (!value) return null;
  return moment(value).fromNow();
};

const numberDefault = value => {
  if (!isFinite(value)) return value;
  return value.toLocaleString();
};

const numberPercent = value => {
  if (!isFinite) return value;
  return value.toLocaleString(undefined, { style: "percent", minimumFractionDigits: 0 });
};

export default {
  duration: {
    default: duration,
  },
  date: {
    default: date,
    short: dateShort,
    medium: dateMedium,
    long: dateLong,
  },
  timestamp: {
    relative: relative,
  },
  number: {
    default: numberDefault,
    percent: numberPercent,
  },
};
